import { useState, useContext, useEffect } from "react";
import {Listbox, ListboxButton,ListboxOption, ListboxOptions } from '@headlessui/react'
import axios from "axios";
// import Sidebar from "./components/Sidebar";
import TranslateBox from "../components/AiHub/Translation/TranslateBox";
import Layout from '../components/Layout/Layout';

import FeedbackForm from "../components/AiHub/Translation/FeedbackForm";
import PromptViewer from "../components/AiHub/Translation/PromptViewer";
import DictionaryViewer from "../components/AiHub/Translation/DictionaryViewer";
import { AuthContext } from "../hoc/AuthContext"; // Adjust path as needed
import {  CheckIcon, ChevronUpDownIcon} from '@heroicons/react/24/outline'
import { getDomains } from "../components/utils/utils";


// const COMPONENTS = {
//   translate: <TranslateBox />,
//   feedback: <FeedbackForm />,
//   prompt: <PromptViewer />,
//   dictionaries: <DictionaryViewer />
// };

// const domain = [
    
//   { id: 16, name: 'OMH - Tamil', domain_url : "tamil-onlymyhealth.com", avatar: 'https://www.jagranimages.com/images/wms/onlymyhealth.svg', },
//   { id: 22, name: 'Jagran Josh' , domain_url: "jagranjosh.com", avatar: 'https://www.jagranimages.com/images/wms/jagran_english.svg', },
  
// ]

const API_BASE_URL = process.env.REACT_APP_OLD_WMS_API_BASE_URL;

export default function Translation() {
  const { authUserData } = useContext(AuthContext);
  const [active, setActive] = useState("translate");
  const [selectedProduct, setSelectedProduct] = useState(null);

  // 🔹 Shared state for TranslateBox output
  const [translatedOutput, setTranslatedOutput] = useState("");
  const [accessProductList, setAccessProductList] = useState([]); // store all access products
  const [hasProductPermission, setHasProductPermission] = useState(null);
  

  const COMPONENTS = {
    translate: (
      <TranslateBox
        output={translatedOutput}
        setOutput={setTranslatedOutput}
        selectedProduct={selectedProduct?.domain_url.replace('.com', '')}
        selectedProductDetails={selectedProduct}
      />
    ),
    //feedback: <><div className="border p-4 rounded shadow bg-gray-50">This section is presently under development and will be available soon.</div></>,
    feedback: <FeedbackForm selectedProduct={selectedProduct?.domain_url.replace('.com', '')} />,
    prompt: <PromptViewer selectedProduct={selectedProduct?.domain_url.replace('.com', '')} />,
    dictionaries: <DictionaryViewer selectedProduct={selectedProduct?.domain_url.replace('.com', '')} />,
  };

  //console.log(selectedProduct)

  useEffect(() => {
    // Fetch user roles only once
    let authToken = authUserData.auth_token;
    let userData = authUserData.userData;
    //console.log(userData)
    //let authToken = `5f4dcc3b5aa765d61d8327deb882cf99`;
    /*axios.get(`${API_BASE_URL}user-roles`, {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    })
    .then(response => {
      const list = response.data?.data?.access_products || [];
      setAccessProductList(list);
  
      // Set default product (example: id = 22)
      const product = domain.find(item => item.id === 22); 
      setSelectedProduct(product);
    })
    .catch(error => {
      console.error(error);
    });*/

    const product = getDomains().find(item => item.id === 22); 
    setSelectedProduct(product);
    if(userData.role === 'admin'){
      
      setAccessProductList(getDomains());
    }

    if(userData.role !== 'admin'){
      
      setAccessProductList(authUserData.productslist);
    }

    // const product = domain.find(item => item.id === 22); 
    //   setSelectedProduct(product);
  }, []);
  
  useEffect(() => {
    console.log(accessProductList)
    if (selectedProduct && accessProductList.length > 0) {
      const matched = accessProductList.find(item => item.id === selectedProduct.id);
      setHasProductPermission(!!matched); // true if found, false if not
    }
   
   //setHasProductPermission(true);
  }, [selectedProduct, accessProductList]);

  const menu = [
    { id: "translate", label: "Translate" },
    { id: "feedback", label: "Feedback" },
    { id: "prompt", label: "Core Prompt" },
    { id: "dictionaries", label: "Dictionaries" }
  ];

  //console.log(hasProductPermission)
  return (
    <Layout>
   
      {/* <Sidebar active={active} setActive={setActive} /> */}
      <main >
      <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className='flex justify-center mb-6'>
        {selectedProduct &&
      <Listbox value={selectedProduct} onChange={setSelectedProduct}>
              <div className="relative">
                <ListboxButton className="relative w-40 lg:w-52 cursor-default rounded-full bg-white py-2.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500 text-xs sm:text-sm">
                  <span className="flex items-center">
                    <img alt="" src={selectedProduct.avatar} className="h-5 w-5 shrink-0 rounded-full" />
                    <span className="ml-3 block truncate">{selectedProduct.name}</span>
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                    <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                  </span>
                </ListboxButton>

                <ListboxOptions
                  transition
                  className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-2xl bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                >
                  
                  {getDomains().map((person) => (
                    <ListboxOption
                      key={person.id}
                      value={person}
                      className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-red-600 data-[focus]:text-white"
                    >
                      <div className="flex items-center">
                        <img alt="" src={person.avatar} className="h-5 w-5 shrink-0 rounded-full bg-white" />
                        <span className="ml-3 block truncate text-xs sm:text-sm font-normal group-data-[selected]:font-semibold">
                          {person.name}
                        </span>
                      </div>

                      <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-red-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                        <CheckIcon aria-hidden="true" className="h-5 w-5" />
                      </span>
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </div>
            </Listbox> }
          </div>
        </div>
       {hasProductPermission ? <> <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className='flex justify-center mb-6'>
                        <nav className="flex divide-x divide-gray-200 rounded-lg shadow overflow-hidden">
                            
                            {menu.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => setActive(item.id)}
                                className={`group relative min-w-0 flex-1 overflow-hidden ${
                                    active === item.id
                                        ? "bg-red-500 hover:bg-red-600 text-gray-50 hover:text-gray-50"
                                        : "bg-gray-50 hover:bg-gray-100 text-gray-500 hover:text-gray-500"
                                    } px-8 py-4 text-center text-sm font-bold uppercase focus:z-10`}
                            >
                                <span>{item.label}</span>
                                <span
                                    aria-hidden="true"
                                    className={`${
                                        active === item.id
                                            ? "bg-red-500"
                                            : ""
                                        } absolute inset-x-0 bottom-0 h-0.5`}
                                />
                            </button>
                            ))}
                        </nav>
            </div>
        </div>
        <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className="flex-1 overflow-y-auto p-6 ">
            {COMPONENTS[active]}
            </div>
        </div></> : <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className="flex-1 overflow-y-auto p-6 "><div className="border p-10 text-center rounded shadow bg-gray-50">You don't have access to this product.</div></div>
        </div>}
      </main>
    
    </Layout>
  );
}
